// Site-wide upload banner. The single most important guest action is uploading
// their own media — this keeps it one tap away on every page (hidden on the
// Gästemedien page itself, where the uploader already sits).
import React from 'react';
import { Link } from '../router.jsx';
import { CTA } from '../text.js';

export default function UploadCta() {
	return (
		<div className='uploadcta'>
			<span className='uploadcta__text'>{CTA.text}</span>
			<Link to='/galerie/gaestemedien' className='uploadcta__btn'>
				{CTA.button}
			</Link>
		</div>
	);
}
